import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import {deviceMax} from '../../theme/breakpoints'
import {MainContainer} from '../../theme/mainContainer.styled'
import Button from '../Button/Button'
import SelectComponent from '../Select/Select'

export const FilterBarContainer = styled(MainContainer)`
  flex-direction: row;
  align-items: center;
  display: flex;
  width: 100%;
  gap: ${pxToRem(20)};
  @media ${deviceMax.tablet} {
    flex-direction: column;
    padding: ${pxToRem(25)} ${pxToRem(10)};
  }
`
export const SelectContainer = styled.div`
  flex-direction: row;
  align-items: center;
  display: flex;
  width: 100%;
  padding: 0;
  gap: ${pxToRem(20)};
  @media ${deviceMax.tablet} {
    flex-direction: column;
  }
`

export const WhiteSpace = styled.div`
  width: 100%;
  background-color: ${({theme}) => theme.colors.unique.white};
`

export const Subscribe = styled(Button)`
  height: ${pxToRem(40)};
  min-width: fit-content;
`

export const StyledSelect = styled(SelectComponent)`
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  display: flex;
  width: 100%;
  border: none;
  border-radius: ${pxToRem(5)};
  margin: ${pxToRem(10)} 0;
  cursor: pointer;

  .react-select__control {
    background-color: ${({theme}) => theme.colors.secondary.grey95};
    border-width: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: ${pxToRem(2)} 0;
  }

  .react-select__indicator-separator {
    width: 0;
  }

  @media ${deviceMax.tablet} {
    margin: initial;
  }
`
